module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-wrap"
  }, [_c('div', {
    staticClass: "location"
  }, [_vm._m(0), _c('div', {
    staticClass: "l-row2"
  }, [_c('mt-cell', [_c('mt-radio', {
    attrs: {
      "options": _vm.options
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)], 1)]), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "fooddesc"
  }, [_c('div', {
    staticClass: "f-row1"
  }, [_vm._v("已点菜品")]), _vm._l((_vm.orderList.orderList), function(item) {
    return _c('div', {
      staticClass: "f-row2"
    }, [_c('div', {
      staticClass: "f-title"
    }, [_vm._v(_vm._s(item.title)), (item.taste) ? _c('div', {
      staticStyle: {
        "font-size": "1rem",
        "color": "#666",
        "height": "1.1rem",
        "line-height": "1.1rem"
      }
    }, [_vm._v("(" + _vm._s(item.taste) + ")")]) : _vm._e()]), _c('div', {
      staticClass: "f-count"
    }, [_vm._v(_vm._s(item.count) + "份")]), _c('div', {
      staticClass: "f-price"
    }, [_vm._v("￥" + _vm._s(item.price))])])
  }), _c('div', {
    staticClass: "f-row3"
  }, [_c('div', {
    staticClass: "f-title"
  }, [_vm._v("总计")]), _c('div', {
    staticClass: "f-count"
  }, [_vm._v(_vm._s(_vm.totalsum) + "份")]), _c('div', {
    staticClass: "f-price"
  }, [_vm._v("￥" + _vm._s(_vm.totalprice))])])], 2), _c('div', {
    staticClass: "discount"
  }, [_c('div', {
    staticClass: "d-row1"
  }, [_vm._v("优惠折扣")]), _c('div', {
    staticClass: "d-desc"
  }, [_c('div', {
    staticClass: "member"
  }, [_vm._v("会员优惠折扣")]), _c('div', {
    staticClass: "d-count"
  }, [_vm._v(_vm._s(_vm.discount) + "折")])])]), _c('div', {
    staticClass: "pay-way"
  }, [_c('div', {
    staticClass: "p-row1"
  }, [_c('div', [_vm._v("还需支付")]), _c('div', {
    staticStyle: {
      "color": "#fc2a2a"
    }
  }, [_vm._v("￥" + _vm._s(_vm.dPrice) + " ")])]), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('mt-cell', [_c('mt-radio', {
    attrs: {
      "options": _vm.payWays
    },
    model: {
      value: (_vm.payWay),
      callback: function($$v) {
        _vm.payWay = $$v
      },
      expression: "payWay"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "pay-btn"
  }, [_vm._v("支付                                                 ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row1"
  }, [_vm._v("选择就餐地点"), _c('span', [_vm._v("(如有疑问，请咨询服务人员)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location"
  }, [_c('div', {
    staticClass: "l-row1"
  }, [_vm._v("选择桌号"), _c('span', [_vm._v("(如有疑问，请咨询服务人员)")])]), _c('div', {
    staticClass: "l-row2 select-row"
  }, [_c('select', {
    staticClass: "select"
  }, [_c('option', [_vm._v("请选择桌号")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "humancount"
  }, [_c('div', {
    staticClass: "h-row1"
  }, [_vm._v("就餐人数 "), _c('input', {
    staticClass: "h-input",
    attrs: {
      "placeholder": "请输入就餐人数"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-164609a3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pay.vue
// module id = 109
// module chunks = 0